export default __webpack_public_path__ + "static/right-gradient-551451a9dfcfb71ee9e019115b1a3778.svg";